export type InventoryReceivedStatus = 'pending' | 'received' | 'inspected' | 'cancelled'

export interface InventoryReceivedRow {
  id: string
  code: string
  receivedDate: string
  sourceWarehouse: string
  destinationWarehouse: string
  status: InventoryReceivedStatus
}

export interface InventoryReceivedLine {
  id: string
  itemId: string
  batchId: string
  previousQuantity: number
  quantityReceived: number
  balanceQuantity: number
}

export interface InventoryReceived {
  id: string
  code: string
  receivedDate: string
  sourceWarehouseId: string
  destinationWarehouseId: string
  destinationBranchId: string
  sourceWarehouseName?: string
  destinationWarehouseName?: string
  remarks: string
  status: InventoryReceivedStatus
  attachmentName?: string
  lines: InventoryReceivedLine[]
}

export function newReceivedLine(): InventoryReceivedLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    previousQuantity: 0,
    quantityReceived: 0,
    balanceQuantity: 0,
  }
}
